module.exports = __webpack_public_path__ + "img/collection-memoireRingsSignature@2x.3d4c4db.webp";